import { Box, Typography, useTheme, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  gap: '1rem',
  padding: '1rem 1.25rem',
  borderRadius: '0.5rem',
  border: `2px solid ${selected ? theme.palette.colors.turquoise : theme.palette.monochrome.monoChrome3}`,
  cursor: 'pointer',
  height: '100%',
}));

const RadioCircle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  flexShrink: 0,
  width: '1.25rem',
  height: '1.25rem',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${selected ? theme.palette.colors.turquoise : theme.palette.monochrome.monoChrome3}`,
}));

const RadioDot = styled(Box)(({ theme }) => ({
  width: '0.75rem',
  height: '0.75rem',
  borderRadius: '50%',
  backgroundColor: theme.palette.colors.turquoise,
}));

interface BannerOptionCardProps {
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
  icon?: JSX.Element;
}

function BannerOptionCard({ title, description, selected, onSelect, icon }: BannerOptionCardProps) {
  const theme = useTheme();

  return (
    <Grid item xl={4} md={4} sm={12}>
      <CardContainer onClick={onSelect} selected={selected}>
        {icon ? <Box sx={{ display: 'flex', flexShrink: 0, width: '2rem', height: '2rem' }}>{icon}</Box> : null}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: '1.25rem', fontWeight: selected ? 700 : 400 }}>{title}</Typography>
          <Typography sx={{ fontSize: '1.125rem', color: theme.palette.monochrome.monoChrome4 }}>
            {description}
          </Typography>
        </Box>
        <RadioCircle selected={selected}>{selected ? <RadioDot /> : null}</RadioCircle>
      </CardContainer>
    </Grid>
  );
}

export default BannerOptionCard;
